import { render } from "./MyConfirm.vue?vue&type=template&id=be633a0a&scoped=true"
import script from "./MyConfirm.vue?vue&type=script&lang=js"
export * from "./MyConfirm.vue?vue&type=script&lang=js"

import "./MyConfirm.vue?vue&type=style&index=0&id=be633a0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be633a0a"]])

export default __exports__